import { IOption } from '../../components/Select/Select';

interface INameAndId {
  name: string;
  id: number | string;
}

type TGetAutoCompleteOptionsArray = (someArray: INameAndId[]) => IOption[];

export const getAutoCompleteOptionsArray: TGetAutoCompleteOptionsArray = someArray =>
  someArray.map(({ name, id }) => ({
    label: name,
    value: id.toString()
  }));
